import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center pa-3" }

import { withDefaults, ref, watch, onMounted } from 'vue';
import {
  AtomDatePicker,
  AtomInput,
  SearchIcon,
  AtomButton,
  EditIcon,
  DownloadIcon,
  PaperUploadIcon,
  FolderIcon,
  SettingIcon,
  ArrowDown3Icon,
  DeleteIcon,
} from '@/components/atoms';

interface IProps {
  modelValue?: any;
  title?: string;
  hasSearch?: boolean;
  hasOptions?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeFilters',
  props: {
    modelValue: {},
    title: {},
    hasSearch: { type: Boolean },
    hasOptions: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "handleUpload", "handleCopy", "handleDownloadExcel", "handleDownloadPdf", "handlePrinter", "handleBlur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const search = ref<string>('');

const emit = __emit;
watch(
  () => search.value,
  () => {
    emit('update:modelValue', search.value);
  }
);
onMounted(() => {
  search.value = props.modelValue;
});
function handleBlur() {
  console.log('foi');
  emit('handleBlur', search.value);
}

function clear() {
  search.value = '';
  emit('handleBlur', search.value);
}

function handleUpload() {
  emit('handleUpload');
}

function handleCopy() {
  emit('handleCopy');
}
function handleDownloadExcel() {
  emit('handleDownloadExcel');
}
function handleDownloadPdf() {
  emit('handleDownloadPdf');
}
function handlePrinter() {
  emit('handlePrinter');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "areaFilter")
  ]))
}
}

})